var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbullet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 15c0-8.28427 6.71573-15 15-15 8.2803.00964345 14.9904 6.71973 15 15 0 8.2843-6.7157 15-15 15-8.28427 0-15-6.7157-15-15zm15.1025 6.8616 8.5563-11.6113c.2892-.35801.3583-.84603.1798-1.27028-.1784-.42425-.5756-.7161-1.0338-.75967s-.9033.16819-1.1585.5512l-7.7838 10.56375-5.095-4.0762c-.53917-.4315-1.32603-.3442-1.7575.195-.43147.5391-.34417 1.326.195 1.7575l6.11 4.885c.2671.2087.6069.3015.943.2573.3362-.0442.6404-.2216.8445-.4923z",
    fill: "#5532c8",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbullet);
export default __webpack_public_path__ + "static/media/checkbullet.d27a3244b5c57425f322f73accdec922.svg";
export { ForwardRef as ReactComponent };